import { RecommendationBundlesUI } from "./RecommendationBundlesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";

export function RecommendationBundles({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const placementId = configProps?.placementId
    ? String(configProps.placementId)
    : "";

  const {
    variant: {
      aliases: { skuId },
    },
  } = useVariant(product);
  const { browsePageHierarchy } = product;
  const hasBrowsePageHierarchy =
    browsePageHierarchy && browsePageHierarchy.length > 1;
  const isCtaPremiumDesign = flags?.ctaPremiumDesign?.value === true;

  const shouldShow = placementId && hasBrowsePageHierarchy;

  if (!shouldShow) {
    return null;
  }

  const pageHierarchy = browsePageHierarchy
    .filter(({ categoryId }) => categoryId !== "rootCategory")
    .map(
      ({ name, categoryId }) => `${name.replace(/[\W_]+/g, "")}-${categoryId}`,
    )
    .join("_");

  return (
    <RecommendationBundlesUI
      productId={product.aliases.pimProductId}
      placement={placementId}
      testId="recommendation-bundles-panel"
      skuId={skuId}
      pageHierarchy={pageHierarchy}
      isCtaPremiumDesign={isCtaPremiumDesign}
    />
  );
}
